import { render, staticRenderFns } from "./ChatFeedback.vue?vue&type=template&id=6398abf0&"
import script from "./ChatFeedback.vue?vue&type=script&lang=ts&"
export * from "./ChatFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports